class pt_widgets {
  constructor(ob) {
    console.log("ob", ob);
    this.stock_available = ob.stock_available;
    this.stock_sold = ob.stock_sold;
    this.min_available_stock = ob.min_available_stock;
    this.stock_update_interval = ob.stock_update_interval;
    this.range_for_visitors = ob.range_for_visitors;
    this.visitor_update_interval = ob.visitor_update_interval;
    this.visitor_elm = document.querySelector(".visitors-count");
    this.available_elm = document.querySelector(".stock-available");
    this.sold_elm = document.querySelector(".stock-sold");
    this.init();
  }

  init() {
    if (this.visitor_elm) this.show_visitors();
    if (this.available_elm || this.sold_elm) this.show_stock();
  }

  show_visitors() {
    if (!this.range_for_visitors) return !1;
    let e = parseInt(this.range_for_visitors),
      t = this.visitor_elm,
      o = this.randomizer(e, 11);
    t.innerText = o;
    this.update_visitors(t, o);
  }
  update_visitors(e, t) {
    setInterval(() => {
      let o = this.randomizer(t, 11);
      e.innerText = o;
    }, 1e3 * this.visitor_update_interval);
  }

  show_stock() {
    let e = parseInt(this.stock_available),
      t = parseInt(this.stock_sold),
      o = parseInt(this.min_available_stock),
      i = "stock_" + e + "-" + t,
      s = e + t,
      d = this.randomizer(e, 10),
      n = this.available_elm,
      r = this.sold_elm,
      a = this.getCookie("dz-stock-cookie"),
      b = this.getCookie("dz-stock-tag");
    b && b === i
      ? b === i && a && (d = a)
      : this.setCookie("dz-stock-tag", i, 1);
    let _ = s - d;
    if (n) n.innerText = d + " left";
    if (r) r.innerText = _ + " sold";
    this.setCookie("dz-stock-cookie", d, 1);
    this.update_stock(s, d, o);
  }

  update_stock(e, t, o) {
    let i = this.available_elm,
      s = this.sold_elm,
      d = parseInt(this.stock_update_interval),
      n = setInterval(() => {
        if (o < t) {
          t -= Math.floor(3 * Math.random());
          let o = e - t;
          if (i) i.innerText = t + " left";
          if (s) s.innerText = o + " sold";
          this.setCookie("dz-stock-cookie", t, 1);
        } else {
          clearInterval(n),
            this.setCookie("dz-stock-cookie", this.stock_available, 1);
        }
      }, 1e3 * d);
  }

  setCookie(e, t, o) {
    const i = new Date();
    i.setTime(i.getTime() + 24 * o * 60 * 60 * 1e3);
    let s = "expires=" + i.toUTCString();
    document.cookie = e + "=" + t + ";" + s + ";path=/";
  }
  getCookie(e) {
    let t = e + "=",
      o = document.cookie.split(";");
    for (let e = 0; e < o.length; e++) {
      let i = o[e];
      for (; " " == i.charAt(0); ) i = i.substring(1);
      if (0 == i.indexOf(t)) return i.substring(t.length, i.length);
    }
    return "";
  }
  randomizer(e, t) {
    let o = Math.floor(Math.random() * t);
    return Math.random() > 0.5 ? (e -= o) : (e += o), e;
  }
}
